export const Endpoints = {
  GET_PLACES: '/places'
}
